let cloneObj = (obj) => {
    let newObj = obj instanceof Array ? [] : {};
    for (let key in obj) {
        // newObj[key] = typeof obj[key] === 'object' ? cloneObj(obj[key]): obj[key];
        if(typeof obj[key] === 'object' && obj[key] !== null) {
            newObj[key] = cloneObj(obj[key])
        } else {
            newObj[key] = obj[key];
        }
    }
    return newObj;
}

export default {
    cloneObj
}